/* eslint-disable react/require-default-props,react/prop-types,jsx-a11y/no-autofocus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';
import cn from 'classnames';

import Icon from '../../Icon';
import Avatar from '../../Avatar';
import ClickableElement from '../../ClickableElement';
import { COLORS } from '../../../constants/styles';

import style from './index.styl';

@CSSModules(style, { allowMultiple: true })
export default class ChipInput extends Component {
  static propTypes = {
    selected: PropTypes.array,
    onDelete: PropTypes.func,
    onChange: PropTypes.func,
  };

  handleDelete = data => () => {
    const { onDelete } = this.props;
    onDelete(data);
  };

  handleChange = e => {
    const { onChange } = this.props;
    onChange(e.target.value);
  };

  render() {
    const { selected, value, placeholder } = this.props;
    const showInputComponents = selected.length < 1 && value === '';

    return (
      <div styleName="root">
        {selected.map(item => {
          const name = item.displayableName || item.username;
          const additionalClass = get(item, 'teamActingUser')
            ? 'chip--primary'
            : '';

          return (
            <div styleName={cn('chip', additionalClass)} key={item.id}>
              <Avatar
                children={name && name.charAt(0).toUpperCase()}
                size={20}
                src={get(item, 'avatar.thumbMin')}
              />
              <div styleName="text-wrapper">
                <span styleName="text" className="f-14">
                  {name}
                </span>
              </div>
              <ClickableElement
                styleName="icon"
                onClick={this.handleDelete(item)}
              >
                <Icon
                  name="close"
                  size={10}
                  style={{
                    fill: COLORS.white,
                    stroke: COLORS.white,
                  }}
                />
              </ClickableElement>
            </div>
          );
        })}
        {showInputComponents && (
          <label styleName="search-icon">
            <Icon
              name="search"
              style={{
                fill: COLORS.cloudyBlue,
              }}
            />
          </label>
        )}
        <input
          autoFocus
          value={value}
          onChange={e => this.handleChange(e)}
          styleName="text-field"
          placeholder={showInputComponents ? placeholder : ''}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Selectbox/ChipInput.jsx